module.exports = __webpack_public_path__ + "static/media/27_plantilla_cuadrada_combo_simple_cf_stills_pet_2,25L_aq_man.89936fc7.png";